import React, { useState, useEffect, useRef } from 'react';
import logoimage from "../assets/images/10337609.png";
import { RiCustomerServiceFill } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import { RiArrowDropDownLine } from "react-icons/ri";
import { FaShoppingCart } from "react-icons/fa";
import Cartillustration from "../assets/images/Home/Cartillustration.jpg";
import { ImCross } from "react-icons/im";
import { toast } from 'react-toastify';
import  whatsappimage  from '../assets/images/whatsapp.png';

const Navbar = () => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [showLogout, setShowLogout] = useState(false);
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [userRole, setUserRole] = useState(null);

  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cartPlans, setCartPlans] = useState([]);
  const apiUrl = process.env.REACT_APP_BASE_URL; // Use the environment variable

useEffect(() => {
  setName(localStorage.getItem('Name') || '');
  setUsername(localStorage.getItem('username') || '');
  setUserRole(localStorage.getItem('role'));

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowLogout(false);
    }
  };

  document.addEventListener('click', handleOutsideClick);

  // Poll for cart changes every 500ms
  const interval = setInterval(() => {
    const storedPlans = localStorage.getItem('cartPlans');
    if (storedPlans) {
      // Only update if changed
      const parsedPlans = JSON.parse(storedPlans).map(plan => ({
        ...plan,
        quantity: plan.quantity || 1
      }));
      setCartPlans((prevPlans) => {
        const prevJson = JSON.stringify(prevPlans);
        const newJson = JSON.stringify(parsedPlans);
        return prevJson !== newJson ? parsedPlans : prevPlans;
      });
    } else {
      setCartPlans([]);
    }
  }, 500); // You can reduce to 100ms, but not recommended unless needed

  return () => {
    document.removeEventListener('click', handleOutsideClick);
    clearInterval(interval);
  };
}, []);
const handleQuantityChange = (id, newQuantity) => {
  if (newQuantity < 1) {
    toast.error("Minimum quantity must be 1.");
    return;
  }

  // Get the total quantity excluding the current plan
  const otherPlans = cartPlans.filter(plan => plan.planid !== id);
  const otherTotal = otherPlans.reduce((sum, plan) => sum + plan.quantity, 0);

  // Check if new total would exceed 10
  if (otherTotal + newQuantity > 10) {
    toast.error("Total quantity in cart cannot exceed 10.");
    return;
  }

  const updated = cartPlans.map(plan =>
    plan.planid === id ? { ...plan, quantity: newQuantity } : plan
  );

  setCartPlans(updated);
  localStorage.setItem('cartPlans', JSON.stringify(updated));
};



  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };
 
  const handleProfile = () => {
    navigate('/UserProfile');
  };

  const handleNavigate = () => {
    navigate('/HelpSupport');
  };

const handleRemovePlan = (id) => {
  const updated = cartPlans.filter(p => p.planid !== id);
  setCartPlans(updated);
  localStorage.setItem('cartPlans', JSON.stringify(updated));
};

const purchasePlans = async () => {
  const token = localStorage.getItem("token");
  const partnerCode = localStorage.getItem("partnerCode");
  const cartPlans = JSON.parse(localStorage.getItem("cartPlans") || "[]");

  if (!token || !partnerCode || cartPlans.length === 0) {
    toast.error("Missing token, partner code, or cart plans.");
    return;
  }

  const totalQuantity = cartPlans.reduce((sum, plan) => sum + plan.quantity, 0);
  if (totalQuantity > 10) {
    toast.error("Total quantity in cart cannot exceed 10.");
    return;
  }

  const validPlans = cartPlans.filter(plan => plan.quantity <= 3);
  if (validPlans.length === 0) {
    toast.error("All plans have quantity greater than 3. Cannot proceed.");
    return;
  }

  const planCodes = validPlans.flatMap(plan =>
    Array(plan.quantity).fill(plan.plancode)
  );

  const payload = {
    partnerCode: partnerCode,
    planCode: planCodes,
    travelDate: "",
    quantity_plan: 0,
  };

  console.log("Sending payload:", payload);

  try {
    const response = await fetch(`${apiUrl}ESIM/PurhaseSim_Bundle`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (response.ok) {
      console.log("✅ Purchase Success:", data);
      toast.error("Purchase successful!");

      // ✅ Clear the cart and close modal
      setCartPlans([]);
      localStorage.removeItem("cartPlans");
      setIsCartOpen(false);
    } else {
      console.error("❌ Purchase Failed:", data);
      toast.error("Purchase failed. Please check the console.");
    }
  } catch (error) {
    console.error("API Error:", error);
    toast.error("An error occurred during the purchase.");
  }
};

  return (
    <nav className="">
      <div className="flex justify-between items-center mx-auto px-4 py-2">
        <div className="font-bold text-lg"></div>

        <div className="flex items-center gap-4 mt-4">
          {userRole === "Partner" && (
            <div
              className=" rounded-full p-2 cursor-pointer"
              onClick={handleNavigate}
            >
              <RiCustomerServiceFill size={28} className="text-lg" />
            </div>
          )}

          {/* Cart Icon */}
          <div
            className="relative cursor-pointer"
            onClick={() => setIsCartOpen(true)}
          >
            <FaShoppingCart size={29} className="text-xl" />
            {cartPlans.length > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {cartPlans.length}
              </span>
            )}
          </div>

          {/* User Avatar + Dropdown */}
          <div className="relative flex items-center" ref={dropdownRef}>
            <div className="w-auto h-8 rounded-full mr-2 bg-[#ffffff] text-black  flex items-center justify-center p-6 shadow-md border-2">
              <img
                src={logoimage}
                className="w-6 h-6 rounded-full"
                alt="User"
              />
              <div className="text-black font-bold ml-2 flex items-center">
                <button>{name}</button>
                <RiArrowDropDownLine
                  size={40}
                  onClick={() => setShowLogout(!showLogout)}
                />
              </div>
            </div>

            {showLogout && (
              <div className="absolute top-12 right-0 bg-white border border-gray-300 rounded-md p-2 shadow-lg z-50">
                <button
                  className="block w-full text-left py-2 px-4 text-gray-800 hover:bg-gray-200"
                  onClick={handleProfile}
                >
                  Profile
                </button>
                <hr />
                <button
                  className="block w-full text-left py-2 px-4 text-gray-800 hover:bg-gray-200"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Cart Modal (Right Side Drawer) */}
{isCartOpen && (
  <div className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50">
    <div className="bg-white w-full max-w-md h-screen p-6 shadow-lg relative overflow-hidden flex flex-col">
      <button
        onClick={() => setIsCartOpen(false)}
        className="absolute top-6 right-2 text-xl font-bold text-gray-600 hover:text-red-500"
      >
        <ImCross size={20} color="black" />
      </button>

      <h1 className="text-5xl font-bold">Cart</h1>

      {cartPlans.length === 0 ? (
        <>
        <img src={Cartillustration}  alt="User" /> 
        <h1 className=" text-5xl font-bold text-center text-gray-600 flex-grow">Your cart is empty.</h1>
        </>
      ) : (
        <ul
          className="overflow-y-auto pr-2"
          style={{ height: 'calc(100vh - 30px)' }} // Adjust height to leave space for header + button
        >
          {cartPlans.map((plan, idx) => (
            <li
              key={plan.planid || idx}
              className="flex justify-between items-center border-b pb-2"
            >
              <div className="flex items-center">
                <img
                  src={`https://www.airhubapp.jp/assets/flags/${plan.country}.svg`}
                  alt={`${plan.country} flag`}
                  className="w-8 h-8 mr-2"
                />
                <span className="leading-7 font-semibold text-base">
                  {plan.planname || plan.country}
                </span>
              </div>

              <div className="flex flex-col items-end space-y-1">
                <p className="text-sm text-gray-700 font-medium">
                  ${(plan.sellingcost * plan.quantity).toFixed(2)}
                </p>
                <div className="flex items-center space-x-2">
                  <button
                    className="px-2 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
                    onClick={() => handleQuantityChange(plan.planid, plan.quantity - 1)}
                  >
                    -
                  </button>
                  <span>{plan.quantity}</span>
                  <button
                    className="px-2 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
                    onClick={() => handleQuantityChange(plan.planid, plan.quantity + 1)}
                  >
                    +
                  </button>
                </div>
                <button
                  className="text-red-500 hover:underline text-sm"
                  onClick={() => handleRemovePlan(plan.planid)}
                >
                  Remove
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}

      {/* Button at bottom via flex grow push */}
      {cartPlans.length > 0 && (
        <div className="mt-4">
          <button
            className="w-full font-bold rounded-lg bg-brand-green-selected p-3 text-brand-white"
            onClick={purchasePlans}
          >
            Proceed to Buy
          </button>
        </div>
      )}
    </div>
  </div>
)}
 <div className="fixed right-5 bottom-[90px] z-50  md:block w-[50px] h-[50px]">
                  <a
                    href="https://wa.me/14159965610"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full h-full rounded-full transition-shadow duration-300 hover:shadow-[0_0_15px_rgba(37,211,102,0.7)]"
                  >
                    <img
                      src={whatsappimage}
                      alt="WhatsApp"
                      className="w-full h-full object-contain "
                    />
                  </a>
                </div>

    </nav>
  );
};

export default Navbar;